import { ClickEventComponentNames } from 'features/analytics';
import { logButtonClick } from 'features/navigation/utils/analytics';

export const logCTAEvent = (name: string) => {
  logButtonClick({
    attributes: {
      component: ClickEventComponentNames.PRODUCT_DETAIL_CLOSE_ACTION_CTA,
      name,
    },
  });
};
